export interface CookieConsent {
  version: number;
  essential: boolean;
  ads: boolean;
  analytics: boolean;
  decided: boolean;
}

export const COOKIE_CONSENT_SCHEMA_VERSION = 1;

export const DEFAULT_COOKIE_CONSENT: CookieConsent = {
  version: COOKIE_CONSENT_SCHEMA_VERSION,
  essential: true,
  ads: false,
  analytics: false,
  decided: false
};
